/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".clear-right-padding[_ngcontent-%COMP%]{padding-right:0}.clear-left-padding[_ngcontent-%COMP%], .padL7[_ngcontent-%COMP%]{padding-left:7px}.red[_ngcontent-%COMP%]{color:red}.box-shadow-no[_ngcontent-%COMP%]   .c-btn[_ngcontent-%COMP%]{box-shadow:none!important;padding:5px 0}"];
export { styles as styles };
